<template>
  <div class="wrapper">
    <ul class="yardList" v-if="list.length != 0">
      <li class="title">大楼列表</li>
      <li @click="go(item)" v-for="(item,index) in list" :key="index">
        {{item.buildingName}}
      </li>
    </ul>
    <div v-if="list.length == 0" class="not_class">暂无信息</div>
  </div>
</template>

<script>
import { selectBuilding } from "@/request/api.js"
import { GetRequest } from "@/tool/parameter.js"
export default {
  data() {
    return {
      list: []
    }
  },
  async created() {
    document.title = GetRequest("hspName")
    let res = await selectBuilding({ hspCode: GetRequest("hspCode")})
    this.list = res.data.obj
  },
  methods: {
    go(item){
      sessionStorage.setItem("BuildingInformation",JSON.stringify(item))
      this.$router.push("/HospitalNavigation/BuildingInformation")
    }
  },
}
</script>


<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .yardList{
    margin-top: 10px;
    background-color: #FFF;
    display: flex;
    flex-flow: column nowrap;
    letter-spacing: 1px;
    font-weight: bold;
    >li{
      flex: 1;
      padding: 20px;
      border: 1px solid #eee;
      display: flex;
      flex-flow: row nowrap;
      font-size: 16px;
    }
    .title{
      color: #00b3ff;
      font-size: 18px;
      padding: 10px 20px;
    }
  }
  .not_class{
    margin-top: 40px;
    font-size: 18px;
    text-align: center;
    letter-spacing: 1px;
    color: #aaa;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/website/HospitalNavigation/buildingSelect.vue